import { gql, type TypedDocumentNode } from "@apollo/client";
import type { CRMTaskComment } from "@/types";

export type CreateCommentResponse = {
  createComment: {
    code: string;
    success: boolean;
    message: string | null;
    comment: CRMTaskComment | null;
  };
};

export type CreateCommentVariables = {
  input: {
    content: string;
    commentableId: string;
    commentableType: "TASK";
  };
};

export const CREATE_COMMENT_MUTATION: TypedDocumentNode<CreateCommentResponse, CreateCommentVariables> = gql`
  mutation CreateComment($input: BackofficeCRMCreateCommentInput!) {
    createComment(input: $input) {
      code
      success
      message
      comment {
        id
        content
        authorName
        createdAt
        updatedAt
        author {
          id
          name
          email
          photo
        }
      }
    }
  }
`;

export type UpdateCommentResponse = {
  updateComment: {
    code: string;
    success: boolean;
    message: string | null;
    comment: CRMTaskComment | null;
  };
};

export type UpdateCommentVariables = {
  input: {
    id: string;
    content: string;
  };
};

export const UPDATE_COMMENT_MUTATION: TypedDocumentNode<UpdateCommentResponse, UpdateCommentVariables> = gql`
  mutation UpdateComment($input: BackofficeCRMUpdateCommentInput!) {
    updateComment(input: $input) {
      code
      success
      message
      comment {
        id
        content
        authorName
        createdAt
        updatedAt
        author {
          id
          name
          email
          photo
        }
      }
    }
  }
`;

export type DeleteCommentResponse = {
  deleteComment: {
    code: string;
    success: boolean;
    message: string | null;
  };
};

export type DeleteCommentVariables = {
  commentId: string;
};

export const DELETE_COMMENT_MUTATION: TypedDocumentNode<DeleteCommentResponse, DeleteCommentVariables> = gql`
  mutation DeleteComment($commentId: ID!) {
    deleteComment(commentId: $commentId) {
      code
      success
      message
    }
  }
`;
